import { z } from 'zod';

/** Admin — 删除会员（含旗下子账户与关联数据；推荐/二叉下级自动上移） */
export const AdminDeleteUserSchema = z.object({
  /** 必须与待删用户名完全一致 */
  confirm_username: z.string().min(1).max(32),
  /** 删除主号时是否一并删除其全部子账户（默认 true） */
  delete_sub_accounts: z.preprocess(
    (val) => val === true || val === 'true' || val === 1 || val === '1',
    z.boolean(),
  ).default(true),
  note: z.string().min(3).max(500),
  xian: z.boolean(),
});

export type AdminDeleteUserRequest = z.infer<typeof AdminDeleteUserSchema>;
